<!-- =========================================================================================
  File Name: ResourceCreate.vue
  Description: Resource Create Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div v-if="resourceUpdatePermission" id="page-user">
		<vx-card>
			<resource-create-tab-account
				v-if="resourceInfo !== null && resourceUpdatePermission"
				class="mt-4"
				:data="resourceInfo"
			/>
		</vx-card>
	</div>
	<not-permission v-else></not-permission>
</template>

<script>
import NotPermission from "@/views/pages/NotPermission.vue";
import ResourceCreateTabAccount from "./ResourceEditTabAccount.vue";
import moduleResource from "@/store/resource/moduleResource.js";

export default {
	components: {
		NotPermission,
		ResourceCreateTabAccount,
	},
	data() {
		return {
			resourceInfo: null,
		};
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
		this.getResourceById(parseInt(this.$route.params.id));
	},
	computed: {
		resourceUpdatePermission() {
			return this.$store.getters.checkPermission("RESOURCES_U");
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		getResourceById(resourceId) {
			this.openLoading();
			this.$store
				.dispatch("moduleResource/fetchResourceFilterPaginate", {ids: [resourceId]})
				.then((res) => {
					this.resourceInfo = res.data.records[0];
					this.closeLoading();
					return res.data.records;
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
	},
};
</script>

<style lang="scss" scoped>
#page-user {
	height: 30%;
}
</style>
